var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{ref:"grid",staticClass:"no-grid-border",attrs:{"config":_vm.gridConfig,"addParamsToGetRequest":_vm.addParamsToGetRequest,"getRequestMiddleware":_vm.getRequestMiddleware},on:{"onGet":_vm.handlerGetData}})}
var staticRenderFns = []

export { render, staticRenderFns }